export class ExampleDataApiModel {
    public id!: string;
    public nome!: string;
    public idade!: number;
}
